import { useConfigStore, useSecureConfigStore } from '../state/store/config/useConfigStore';

export const useConfig = () => {
  const { configurationSettings } = useConfigStore();

  if (!configurationSettings) {
    throw new Error('Configuration settings are not available');
  }

  return {
    configurationSettings,
  };
};

export const useSecureConfig = () => {
  const { siteConfigurationSettings } = useSecureConfigStore();

  if (!siteConfigurationSettings) {
    throw new Error('Configuration settings are not available');
  }

  if (!siteConfigurationSettings) {
    throw new Error('Site configuration settings are not available');
  }

  return {
    siteConfigurationSettings,
  };
};
